import { render } from "./ProductionHome.vue?vue&type=template&id=4ecdc41c&scoped=true&ts=true&lang=pug"
import script from "./ProductionHome.vue?vue&type=script&lang=ts"
export * from "./ProductionHome.vue?vue&type=script&lang=ts"

import "./ProductionHome.vue?vue&type=style&index=0&id=4ecdc41c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecdc41c"]])

export default __exports__